import { Light } from './Light.js';
import { PointLight as BABYLON_PointLight } from '@inter-ikea-betrakta-babylonjs/core/Lights/pointLight.js';
import { vector_3 } from '../../../utility/Conversion.js';
import { PointLightShadowController } from '../shadows/PointLightShadowController.js';
import { PointLightVisualizer } from '../debug_visualizers/PointLightVisualizer.js';
import { LightType } from '../../../../api.js';
const FOURPI = 12.5663706144;
export class PointLight extends Light {
    constructor(viewer, position = { x: 0, y: 0, z: 0 }) {
        super(viewer);
        this.type = LightType.POINT_LIGHT;
        this._expermiental_distance_falloff_enabled = true;
        this._babylon_light = new BABYLON_PointLight(`Light_${this.id} (PointLight)`, vector_3(position), this._viewer.scene);
        this.shadow = new PointLightShadowController(this, this._babylon_light, viewer.light_system);
        this.position = position;
        // Set the falloff type to GLTF, the default does not behave like we want it to.
        this._babylon_light.falloffType = BABYLON_PointLight.FALLOFF_GLTF;
        // This is to make sure Babylon's light's photometric scale is 1.0, i.e. we take all responsibility for setting intensity, and we get the intensity we set.
        this._babylon_light.intensityMode = BABYLON_PointLight.INTENSITYMODE_LUMINOUSINTENSITY;
    }
    set expermiental_distance_falloff_enabled(value) {
        if (this._expermiental_distance_falloff_enabled === value)
            return;
        this._expermiental_distance_falloff_enabled = value;
        // Note that we changed the lightFragment shader so FALLOFF_STANDARD does not take distance in consideration.
        this._babylon_light.falloffType = value ? BABYLON_PointLight.FALLOFF_GLTF : BABYLON_PointLight.FALLOFF_STANDARD;
        this._babylon_light._markMeshesAsLightDirty();
        this._viewer.mark_scene_dirty();
    }
    update() {
        this.update_color_and_intensity();
        this.update_parent_material();
        if (this._parent) {
            const parent_updated = this.is_dirty(Light.DIRTY_PARENT_ADDED |
                Light.DIRTY_PARENT_TRANSFORM |
                Light.DIRTY_POSITION);
            if (parent_updated) {
                this._babylon_light.position = vector_3(this.get_world_position());
                this.mark_dirty(Light.DIRTY_SHADOW_MAP);
            }
        }
        else {
            if (this.is_dirty(Light.DIRTY_POSITION)) {
                this._babylon_light.position.set(this.position.x, this.position.y, this.position.z);
                this.mark_dirty(Light.DIRTY_SHADOW_MAP);
            }
        }
    }
    set_intensity_lumen(lumen) {
        // We assume that the default light type is omnidirectional,
        // meaning it emits its lumen across the entire unit sphere
        // which has an area of 4*pi. So to convert lumen to candela,
        // we divide by 4*pi.
        this.intensity = lumen / FOURPI;
    }
    set_intensity_candela(cd) {
        this.intensity = cd;
    }
    create_debug_geometry() {
        const { line_manager, light_system, scene } = this._viewer;
        this._debug_geometry = new PointLightVisualizer(this, line_manager, light_system.debug_color_mode, scene);
    }
}
//# sourceMappingURL=PointLight.js.map